import '@firebase/functions-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/functions/dist/index.esm.js
// module id = 579
// module chunks = 14